import { render } from "./px-counter.vue?vue&type=template&id=6cb0c854&scoped=true&ts=true"
import script from "./px-counter.vue?vue&type=script&lang=ts"
export * from "./px-counter.vue?vue&type=script&lang=ts"

import "./px-counter.vue?vue&type=style&index=0&id=6cb0c854&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cb0c854"]])

export default __exports__